import React, { useEffect, useState } from "react";
import ResizeListener from "../../../../../utility/ResizeListener";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { CustomInput } from "../../../../components/customInput/CustomInput";
import { BlackClear } from "../../../../resources/assetsManager";
import {
  BG_COLOR,
  LIGHT_GREY_BG_MODAL,
  WHITE_COLOR,
} from "../../../../resources/colorsManager";

function AddCustomerForUpiModal({ onClickSubmit, onClose }) {
  const { width, height } = ResizeListener();
  const [step, setStep] = useState(0);

  const [merchantName, setMerchantName] = useState("");
  const [brandName, setBrandName] = useState("");
  // const [franchise, setFranchise] = useState("");
  // const [genre, setGenre] = useState("");
  // const [legalName, setLegalName] = useState("");
  // const [ownership, setOwnership] = useState("");
  // const [mcc, setMcc] = useState("");
  // const [transferType, setTransferType] = useState("");
  // const [onboardingType, setOnboardingType] = useState("");
  // const [merchantType, setMerchantType] = useState("");
  const [disabled, setDisabled] = useState(true);
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    marginBottom: 15,
    height: 50,
    width: "100%",
    boxShadow: "none",
    minWidth: 280,
    maxWidth: 400,
  };

  const selectStyles = {
    minWidth: 280,
    maxWidth: 400,
    backgroundColor: "#F3F3F3",
    height: 50,
    width: "100%",
    borderRadius: 5,
    margin: 0,
    marginRight: 0,
    marginBottom: 20,
  };
  useEffect(() => {
    if (
      merchantName !== "" &&
      brandName !== ""
      // &&
      // franchise !== "" &&
      // genre !== "" &&
      // legalName !== "" &&
      // ownership !== "" &&
      // mcc !== "" &&
      // // transferType !== "" &&
      // onboardingType !== "" &&
      // merchantType !== ""
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [merchantName, brandName]);
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: 20,
        padding: "20px 30px",
        backgroundColor: WHITE_COLOR,
        minWidth: 300,
        borderRadius: 30,
        width: width * 0.29,
        minHeight: height * 0.4,
        height: "100%",
        alignItems: "center",
        maxHeight: height * 0.65,
        paddingBottom: 0,
      }}
    >
      {/* <AddCustomerTabs
        title1="Single Upload"
        title2="Bulk Upload"
        onClick1={() => {
          setStep(0);
        }}
        onClick2={() => {
          setStep(1);
        }}
        currentStep={step}
        style={{
          maxWidth: 400,
        }}
      /> */}

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <p
          style={{
            fontSize: 18,
            fontWeight: "600",
            width: "100%",
            textAlign: "center",
          }}
        >
          Add Customer
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: BG_COLOR,
            padding: 10,
            borderRadius: 6,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <img src={BlackClear} />
        </div>
      </div>

      {step === 0 ? (
        <>
          <div
            style={{
              width: "100%",
              margin: "20px 0px",
              marginLeft: 20,
            }}
          >
            <p
              style={{
                fontSize: 14,
                color: "#888888",
                fontFamily: "Roboto",
                padding: 0,
                margin: 0,
              }}
            >
              Customer Basic Information
            </p>
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              overflow: "auto",
              alignItems: "center",
              justifyContent: "center",
              columnGap: 10,
            }}
          >
            <CustomInput
              value={merchantName}
              onChange={(data) => setMerchantName(data)}
              inputStyles={{ ...inputStyle }}
              placeholder="Merchant Name"
              type="input"
              validator="name"
            />
            {/* <CustomInput
              value={transferType}
              onChange={(data) => setTransferType(data)}
              placeholder="Transfer Type"
              type="select"
              validator="name"
              inputStyles={{
                ...inputStyle,
                backgroundColor: "transparent",
                border: "none",
                margin: 0,
              }}
              dropdownStyle={{
                ...inputStyle,
                fontSize: 16,
              }}
              options={transferTypes}
            /> */}
            <CustomInput
              value={brandName}
              onChange={(data) => setBrandName(data)}
              inputStyles={{ ...inputStyle }}
              placeholder="Brand Name"
              type="input"
              validator="comment"
            />
            {/* <CustomInput
              value={mcc}
              onChange={(data) => setMcc(data)}
              inputStyles={{ ...inputStyle }}
              placeholder="MCC"
              type="input"
              validator="comment"
            />{" "} */}
            {/* <CustomInput
              value={franchise}
              onChange={(data) => setFranchise(data)}
              inputStyles={{ ...inputStyle }}
              placeholder="Franchise"
              type="input"
              validator="comment"
            /> */}
            {/* <CustomInput
              value={legalName}
              onChange={(data) => setLegalName(data)}
              inputStyles={{ ...inputStyle }}
              placeholder="Legal Name"
              type="input"
              validator="comment"
            /> */}
            {/* <CustomInput
              value={genre}
              onChange={(data) => setGenre(data)}
              inputStyles={{ ...inputStyle }}
              placeholder="Genre"
              type="input"
              validator="comment"
            /> */}
            {/* <CustomInput
              value={merchantType}
              onChange={(data) => setMerchantType(data)}
              inputStyles={{
                ...selectStyles,
              }}
              dropdownStyle={{
                width: "100%",
                padding: 0,
                margin: 0,
                minWidth: 280,
                maxWidth: 400,
              }}
              type="select"
              validator="name"
              options={merchantTypes}
            /> */}
            {/* <CustomInput
              value={onboardingType}
              onChange={(data) => setOnboardingType(data)}
              inputStyles={{
                ...selectStyles,
              }}
              dropdownStyle={{
                width: "100%",
                minWidth: 280,
                maxWidth: 400,
              }}
              type="select"
              validator="name"
              options={onboardingTypes}
            /> */}
            {/* <CustomInput
              value={ownership}
              onChange={(data) => setOwnership(data)}
              placeholder=""
              type="select"
              validator="name"
              options={ownershipTypes}
              // inputStyles={{
              //   ...inputStyle,
              //   backgroundColor: "transparent",
              //   border: "none",
              //   margin: 0,
              // }}
              // dropdownStyle={{
              //   ...inputStyle,
              //   fontSize: 16,
              // }}

              inputStyles={{
                ...selectStyles,
              }}
              dropdownStyle={{
                width: "100%",
                padding: 0,
                margin: 0,
                minWidth: 280,
                maxWidth: 400,
              }}
            /> */}
          </div>
          <div>
            <CustomButton
              title="Submit"
              styles={{
                border: "none",
                margin: "10px 0px 25px 0px",
              }}
              disabled={disabled}
              onClick={() => {
                onClickSubmit([
                  {
                    merchantName,
                    brandName,
                    // franchise,
                    // genre,
                    // legalName,
                    // ownership,
                    // mcc,
                    // // transferType,
                    // onboardingType,
                    // merchantType,
                  },
                ]);
              }}
            />
          </div>{" "}
        </>
      ) : (
        <>{/* <AddCustomerBulk /> */}</>
      )}
    </div>
  );
}

export default AddCustomerForUpiModal;
